import { FC } from 'react';
import {
  StyledBottomContent,
  StyledColumn,
  StyledCompositionColumnContainer,
  StyledContent,
  StyledContentIcon,
  StyledContentSeparator,
  StyledPercentage,
  StyledRow,
  StyledSampleCompositionCointainer,
  StyledTitle,
  StyledTopContent,
  StyledTotalDetails,
} from './SampleComposition.styles';

import { SampleCompositionProps } from './SampleComposition.types';
import { useTranslation } from 'react-i18next';
import { COMMON_TRANSLATION } from '@constants/index';
import { Sizes, Weights } from '@/common/types';
import { NumberText } from '@/common/components';

const SampleComposition: FC<SampleCompositionProps> = ({
  details,
  icon,
  id,
  isSeriesEmpty,
  percentage,
  sampleName,
  total,
}) => {
  const { t } = useTranslation(COMMON_TRANSLATION);

  return (
    <StyledSampleCompositionCointainer data-testid={'sample-composition'}>
      <StyledCompositionColumnContainer>
        <StyledColumn data-testid={'sample-composition-column'}>
          <StyledTitle>{sampleName}</StyledTitle>
          <StyledRow>
            {icon && <StyledContentIcon> {icon} </StyledContentIcon>}
            <StyledContent>
              <StyledTopContent>
                <NumberText testId={`${id}-sample-composition-total`} size={Sizes.MEDIUM} weight={Weights.BOLD}>
                  {!isSeriesEmpty ? total : t('not_applicable')}
                </NumberText>
                <StyledContentSeparator />
                <StyledPercentage data-testid={`${id}-sample-composition-percentage`}>
                  {!isSeriesEmpty ? `${percentage}%` : t('not_applicable')}
                </StyledPercentage>
              </StyledTopContent>
              <StyledBottomContent>{details && <StyledTotalDetails>{details}</StyledTotalDetails>}</StyledBottomContent>
            </StyledContent>
          </StyledRow>
        </StyledColumn>
      </StyledCompositionColumnContainer>
    </StyledSampleCompositionCointainer>
  );
};

export default SampleComposition;
